import Vue from "vue";
import Router from "vue-router";
import { BASE_CONFIG } from "@/config/config.js";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return (originalPush && originalPush.call(this, location)) || "";
};

let defaultRouter = {
  path: "/",
  name: "Home",
  meta: {
    title: "首页-绿地香港"
  },
  component: (resolve) => require(["@/pages/index/index"], resolve)
};
let generalRouter = {
  path: "*",
  name: "default",
  component: (resolve) => require(["@/pages/index/index"], resolve)
};

if (window.location.origin === BASE_CONFIG.OFFICIAL_CONFIG_URL_ORIGIN) {
  defaultRouter = {
    path: "/",
    name: "Login",
    meta: { title: "登录-绿地香港" },
    component: (resolve) => require(["@/pages/auth/login"], resolve)
  };
  generalRouter = {
    path: "*",
    name: "default",
    component: (resolve) => require(["@/pages/auth/login"], resolve)
  };
}
const router = new Router({
  scrollBehavior: (to, from, savedPosition) => {
    // 三级路由不移动
    if (to.path.split("/").length === 4 && to.params.id !== "id=1") {
      return {
        el: "#pageContent",
        top: -1000
      };
    } else {
      return { x: 0, y: 0 }; // 期望滚动的位置
    }
  },
  routes: [
    defaultRouter,
    {
      path: "/login",
      name: "Login",
      meta: { title: "登录-绿地香港" },
      component: (resolve) => require(["@/pages/auth/login"], resolve)
    },
    // 配置页面
    {
      path: "/configList",
      name: "ConfigInfo",
      meta: { title: "配置-绿地香港" },
      component: (resolve) =>
        require(["@/pages/configInfo/configList"], resolve)
    },
    {
      path: "/pageMap",
      name: "PageMap",
      meta: {
        title: "网站地图-绿地香港"
      },
      component: (resolve) => require(["@/pages/index/pageMap"], resolve)
    },
    {
      path: "/disclaimer",
      name: "Disclaimer",
      meta: {
        title: "免责申明-绿地香港"
      },
      component: (resolve) => require(["@/pages/index/disclaimer"], resolve)
    },
    // 关于我们
    {
      path: "/aboutUs",
      name: "AboutUs",
      component: (resolve) => require(["@/pages/aboutUs/aboutUs"], resolve),
      children: [
        {
          path: "introduce",
          name: "Introduce",
          meta: {
            title: "企业介绍-绿地香港"
          },
          component: (resolve) =>
            require(["@/pages/aboutUs/pageIntroduce"], resolve)
        },
        {
          path: "chairman",
          name: "Chairman",
          meta: {
            title: "主席致辞-绿地香港"
          },
          component: (resolve) =>
            require(["@/pages/aboutUs/pageChairman"], resolve)
        },
        {
          path: "management",
          name: "Management",
          meta: {
            title: "管理团队-绿地香港"
          },
          component: (resolve) =>
            require(["@/pages/aboutUs/pageManagement"], resolve)
        },
        {
          path: "cooperative",
          name: "Cooperative",
          meta: {
            title: "合作伙伴-绿地香港"
          },
          component: (resolve) =>
            require(["@/pages/aboutUs/pageCooperative"], resolve)
        },
        {
          path: "announcement",
          name: "Announcement",
          meta: {
            title: "中标公示-绿地香港"
          },
          component: (resolve) =>
            require(["@/pages/aboutUs/pageAnnouncement"], resolve)
        }
      ]
    },
    // 投资者关系
    {
      path: "/investor",
      name: "Investor",
      component: (resolve) =>
        require(["@/pages/investorRelations/investorRelations"], resolve),
      children: [
        {
          path: "investorNews/:id",
          name: "InvestorNews",
          meta: {
            title: "企业信息-绿地香港"
          },
          component: (resolve) =>
            require(["@/pages/investorRelations/investorNews"], resolve)
        },
        {
          path: "financialReportsAnnouncements/:id",
          name: "FinancialReportsAnnouncements",
          meta: {
            title: "财报及公告-绿地香港"
          },
          component: (resolve) =>
            require([
              "@/pages/investorRelations/financialReportsAnnouncements"
            ], resolve)
        },
        {
          path: "stockInformation",
          name: "StockInformation",
          meta: {
            title: "价格和走势图-绿地香港"
          },
          component: (resolve) =>
            require(["@/pages/investorRelations/stockInformation"], resolve)
        }
      ]
    },
    // 加入我们
    {
      path: "/joinUs",
      name: "JoinUs",
      component: (resolve) => require(["@/pages/joinUs/joinUs"], resolve),
      children: [
        {
          path: "talentView",
          name: "TalentView",
          meta: {
            title: "人才观-绿地香港"
          },
          component: (resolve) =>
            require(["@/pages/joinUs/talentView"], resolve)
        },
        {
          path: "recruitment",
          name: "Recruitment",
          meta: {
            title: "人才招聘-绿地香港"
          },
          component: (resolve) =>
            require(["@/pages/joinUs/recruitment"], resolve)
        }
      ]
    },
    // 公司业务
    {
      path: "/companyBusiness",
      name: "CompanyBusiness",
      component: (resolve) =>
        require(["@/pages/companyBusiness/companyBusiness"], resolve),
      children: [
        {
          path: "developmentOfRealEstate",
          name: "DevelopmentOfRealEstate",
          meta: {
            title: "匠心筑造 极致品质-绿地香港"
          },
          component: (resolve) =>
            require([
              "@/pages/companyBusiness/developmentOfRealEstate"
            ], resolve)
        },
        {
          path: "realEstate/:id",
          name: "RealEstate",
          meta: {
            title: "房地产+-绿地香港"
          },
          component: (resolve) =>
            require(["@/pages/companyBusiness/realEstate"], resolve)
        }
      ]
    },
    // 新闻中心
    {
      path: "/newsCenter/:id",
      name: "NewsCenter",
      component: (resolve) =>
        require(["@/pages/newsCenter/newsCenter"], resolve)
    },
    // 企业文化
    {
      path: "/enterpriseCulture/:id",
      name: "EnterpriseCulture",
      component: (resolve) =>
        require(["@/pages/enterpriseCulture/enterpriseCulture"], resolve)
    },
    {
      path: "/error",
      name: "error",
      component: (resolve) => require(["@/pages/error"], resolve)
    },
    generalRouter
  ]
});

const specialRouterList = [
  {
    code: "04",
    url: "/newsCenter/01",
    title: "绿地香港要闻-绿地香港"
  },
  {
    code: "04",
    url: "/newsCenter/02",
    title: "媒体关注-绿地香港"
  },
  {
    code: "05",
    url: "/enterpriseCulture/01",
    title: "党建文化-绿地香港"
  },
  {
    code: "05",
    url: "/enterpriseCulture/02",
    title: "社会责任-绿地香港"
  }
];

router.beforeEach((to, from, next) => {
  // 修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    // 特殊title的修改
    specialRouterList.forEach((el) => {
      if (el.url === to.path) {
        document.title = el.title;
      }
    });
  }
  //百度pvuv统计代码
  _hmt.push(["_trackPageview", "/#" + to.fullPath]);

  //记住登出前的路径和参数
  sessionStorage.setItem("defaultGoRout", from.path);
  sessionStorage.setItem("query", JSON.stringify(from.query)); //记住路劲+参数
  if (to.name == "login" || to.name == "default") {
    sessionStorage.setItem("isLoginRout", "1");
  } else {
    sessionStorage.removeItem("isLoginRout");
  }
  console.log(sessionStorage.getItem("isLoginRout"));
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js